function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q19qg8ha3a"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 28315",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(316 446)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "img-placeholder",
    transform: "translate(-316 -446)",
    style: {
      clipPath: "url(#q19qg8ha3a)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3910",
    width: 34,
    height: 34,
    rx: 5,
    transform: "translate(319 449)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "img-holder-icn",
    d: "M1.752 18.831a1.683 1.683 0 0 1-1.231-.521A1.683 1.683 0 0 1 0 17.079V1.759A1.694 1.694 0 0 1 .521.524 1.681 1.681 0 0 1 1.752 0h15.32a1.688 1.688 0 0 1 1.235.523 1.69 1.69 0 0 1 .523 1.236v15.32a1.783 1.783 0 0 1-1.758 1.752H1.752m0-1.752h15.32V1.759H1.752zm0 0zM3.927 14.7h11a.4.4 0 0 0 .379-.234.446.446 0 0 0-.027-.469L12.285 9.98a.45.45 0 0 0-.353-.176.422.422 0 0 0-.351.176L8.538 13.9 6.5 11.112a.446.446 0 0 0-.71 0l-2.19 2.88a.418.418 0 0 0-.052.469.4.4 0 0 0 .379.234",
    transform: "translate(326.55 457.441)",
    style: {
      fill: "#e0e0e0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.008fa9fd1c212ea7ba27af844f35171a.svg";
export { ForwardRef as ReactComponent };